import { useEffect } from 'react';
import { gtm_enabled } from '../../constants';
import { useConsent } from '@buzzfeed/react-components';
import { trackClientPageview } from './client-event-tracking';
import { trackGooglePageview } from './google/client';
import { useProfileUserLayer } from './useUserLayers';

export function usePageviewTracking({ layers = [] }) {
  useConsent('tracking');
  const profileUserLayer = useProfileUserLayer();

  useEffect(() => {
    trackClientPageview(profileUserLayer(), ...layers);
    if (!gtm_enabled) {
      trackGooglePageview();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
